import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=188410f0&scoped=true&lang=pug&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=188410f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188410f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188410f0')) {
      api.createRecord('188410f0', component.options)
    } else {
      api.reload('188410f0', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=188410f0&scoped=true&lang=pug&", function () {
      api.rerender('188410f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/search/SearchResults.vue"
export default component.exports